import { costApi } from 'packages/lib/api/annotations-ops/clients/cost/cost-api';
import { mockCostService } from 'packages/lib/api/annotations-ops/clients/cost/mock/mock-cost-service';
import {
  CostGroupResponse,
  CostQuery,
  CostSeriesQuery,
  CostSeriesResponse,
  CostTaskResponse,
  CostUserQuery,
  CostUserResponse,
  GroupHierarchyResponse,
  GroupHierarchyType,
  TaskTypesQuery,
  TaskTypesResponse,
} from 'packages/lib/api/annotations-ops/contract';

// 2026-10-30 Used Cursor (Claude Opus 5.5) to add CostService dependency injection

/**
 * Every endpoint the Cost tool reads. Components receive one through
 * `CostServiceProvider`; whoever creates that provider chooses the implementation.
 */
export interface CostServiceType {
  /** Part of every SWR key, so responses from different services never share a cache entry. */
  source: string;
  getGroupCost: (query: CostQuery) => Promise<CostGroupResponse>;
  getTimeSeries: (query: CostSeriesQuery) => Promise<CostSeriesResponse>;
  getTaskCost: (taskToken: string) => Promise<CostTaskResponse>;
  getUserCost: (query: CostUserQuery) => Promise<CostUserResponse>;
  getTaskTypes: (query: TaskTypesQuery) => Promise<TaskTypesResponse>;
  getGroupHierarchy: (
    groupType: GroupHierarchyType,
    token?: string
  ) => Promise<GroupHierarchyResponse>;
}

/** Live client. Endpoints without a backend yet stay on mock data. */
export const costService: CostServiceType = {
  ...mockCostService,
  source: 'api',
  getGroupCost: costApi.getGroup,
  getTimeSeries: costApi.getTimeSeries,
};
